export enum UserPassengerListRequestOrder {
  FIRST_NAME_ASC = "FIRST_NAME_ASC",
  FIRST_NAME_DESC = "FIRST_NAME_DESC",
  LAST_NAME_ASC = "LAST_NAME_ASC",
  LAST_NAME_DESC = "LAST_NAME_DESC",
  USERNAME_ASC = "USERNAME_ASC",
  USERNAME_DESC = "USERNAME_DESC",
}

export enum UserPassengerListRequestStatusCriteria {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  ALL = "ALL",
}

export type UserPassengerListRequestQueryParams = {
  cargoCompany?: string;
  cargoCompanyId?: string;
  dispatch?: string;
  dispatchId?: string;
  order?: UserPassengerListRequestOrder;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserPassengerListRequestStatusCriteria;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
  address?: string;
};

type UserPassengerListRequest = {
  cargoCompany?: string;
  cargoCompanyId?: string;
  dispatch?: string;
  dispatchId?: string;
  order?: UserPassengerListRequestOrder;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserPassengerListRequestStatusCriteria;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
  address?: string;
};

export default UserPassengerListRequest;
